import { createFileRoute } from "@tanstack/react-router";

import { ConsoleHome } from "../features/console/account";

export const Route = createFileRoute("/console/home")({
  component: ConsoleHome,
});
